export const Props = () => ({
  //--------------------------------------------------------------------------
  //              Модификатор для выбора внешнего вида тега
  //--------------------------------------------------------------------------
  percent: {
    type: Number,
    default: 0,
    required: true
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});